import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { ArtTreatmentState, ArtTreatmentStore } from './art-treatment.store';

@Injectable()
export class ArtTreatmentQuery extends Query<ArtTreatmentState> {
	readonly lastTouchedAt$ = this.select(state => state.lastTouchedAt);

	get value(): ArtTreatmentState {
		return this.getValue();
	}

	constructor(protected store: ArtTreatmentStore) {
		super(store);
	}
}
